import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import FAQSection from '../components/FAQs';
import SupportContactForm from '../components/SupportContactForm';

const Support = () => {
  return (
    <Box
      w="100%"
      h="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      position={{ base: 'relative', lg: 'fixed' }}
      bg={'blue'}
    >
      <Box
        width={'85%'}
        display={'flex'}
        gap={5}
        flexDirection={{ base: 'column', md: 'row' }}
        mt={{ base: '60px', sm: '70px', lg: '0px' }}
      >
        <Box bg={'white'} flex={2} p={5} borderRadius={'10px'}>
          <Text
            color={'#001E60'}
            fontFamily="EverydaySans-Bold-Web"
            fontSize={['16px', '16px', '18px', '18px', 'x-large']}
            mb={5}
          >
            FAQs
          </Text>
          <FAQSection />
        </Box>
        <Box bg={'white'} flex={1} p={5} borderRadius={'10px'}>
          <Box mb={10}>
            <Text
              color={'#001E60'}
              fontFamily="EverydaySans-Bold-Web"
              fontSize={['16px', '16px', '18px', '18px', 'x-large']}
            >
              Contact Support
            </Text>
          </Box>
          <SupportContactForm />
        </Box>
      </Box>
    </Box>
  );
};

export default Support;
